/*
 * @Author: miroku.yang
 * @Date: 2023-12-30 12:13:54
 * @LastEditors: 
 * @LastEditTime: 2024-03-20 11:59:30
 * @Description: 
 */
import requestHelper from '@/utils/requestHelper'

/**
 *
 * @param data
 * 获取试用期会员
 */
export function getMemberTria(data: any = {}) {
  return requestHelper.post('v4/demand/user/member/trial', data)
}


/**
 *
 * @param data
 * 获取会员套餐详情
 */
export function getMemberTriaPackageInfo(data: any = {}) {
  return requestHelper.post('v4/demand/user/member/trial/package/info', data)
}
